export default __webpack_public_path__ + "static/media/human.228efdd5.svg";